// extracted by mini-css-extract-plugin
export var activeDot = "_79-c";
export var buttonContainer = "_79-9";
export var channelButton = "_79-a";
export var clickable = "_79-d";
export var content = "_79-0";
export var contentFull = "_79-2";
export var contentThird = "_79-1";
export var contentWrapper = "_79-7";
export var description = "_79-5";
export var heightShort = "_79-f";
export var image = "_79-3";
export var imageContainer = "_79-4";
export var selectButton = "_79-e";
export var spinnerContainer = "_79-b";
export var titleContent = "_79-8";
export var titleWrapper = "_79-6";